import React from 'react'
import {firstReview} from '../data/data';
import { Row, Col} from 'react-bootstrap'

const Reviews = () => {
    return (
       <div className='container' id="reviews"> 
         <Row>     
           {firstReview.map((data, i) => {
          return (
            <>                   
              <Col key={i} md={4} >                
                 <img src={data.image} alt={data.alt} />
                  <h3>{data.name}</h3>                  
                    <p>{data.location}</p>
                    {/* {data.type === 'CUSTOMER' ? (
                      <p firstReview>{data.type}</p>
                    ) : ( */}
                      <button vendor firstReview>
                        {data.type}
                      </button>
                    {/* )}                 */}
                  <p>{data.review}</p>                                                  
              </Col>            
            </>        
          );
        })}
         </Row>
        
        </div>
        
    )
}

export default Reviews
